export default __webpack_public_path__ + "static/media/monkey6.76d0821b.JPG";